import { FC, useMemo } from 'react'
import { useNavigate } from 'react-router-dom'
import { SelectLoadingState, Table, VStack } from '@revolut-internal/ui-kit'

import { AssistantDialogueEnty } from 'lib/apiClient'
import { getDebugRouteV2 } from 'lib/router'

import { defineAssistantConversationsTableColumns } from './AssistantConversationsTable.utils'

interface AssistantConversationsTableProps {
  data: AssistantDialogueEnty[]
  loadingState: SelectLoadingState
}

export const AssistantConversationsTable: FC<AssistantConversationsTableProps> = ({
  data,
  loadingState,
}) => {
  const navigate = useNavigate()

  const columns = useMemo(() => defineAssistantConversationsTableColumns(), [])

  const handleRowClick = (dialogueEntry: AssistantDialogueEnty) => {
    navigate(getDebugRouteV2(dialogueEntry.correlationId))
  }

  return (
    <VStack space="s-16">
      <Table
        data={data}
        columns={columns}
        loadingState={loadingState}
        onRowClick={handleRowClick}
        initialState={{
          sortBy: [{ id: 'lastInteraction', desc: true }],
        }}
      />
    </VStack>
  )
}
